export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Environment: dev, beta, or prod
export const ENV = import.meta.env.VITE_ENV || 'dev';

// reCAPTCHA configuration
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
export const DEVICE_PLATFORM = 'WEB';

// Veritrans configuration
export const VERITRANS_TOKEN_API_KEY = import.meta.env.VITE_VERITRANS_TOKEN_API_KEY;

// Google Analytics configuration
export const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;
